module.exports = __webpack_public_path__ + "static/media/SL 18-19-20 upd.84ac9cd9.mp3";